import React from 'react';

import { RackChip } from '../../design/components';
import type { Rack } from '@recipe-rack/shared';

interface RackPickerProps {
  racks: Rack[];
  selected: string[];
  onChange: (next: string[]) => void;
}

/**
 * Multi-select rack picker rendered as a row of clickable `RackChip`s.
 * Toggle on click. `aria-pressed` reflects selection; styling lives in
 * `.rr-rackpicker .rr-rackchip[aria-pressed='true']` in components.css.
 */
const RackPicker: React.FC<RackPickerProps> = ({ racks, selected, onChange }) => {
  if (racks.length === 0) {
    return (
      <div className="rr-rackpicker-empty">
        No racks yet — create one from Manage racks.
      </div>
    );
  }

  const toggle = (rackId: string) => {
    if (selected.includes(rackId)) {
      onChange(selected.filter((id) => id !== rackId));
    } else {
      onChange([...selected, rackId]);
    }
  };

  return (
    <div className="rr-rackpicker" role="group" aria-label="Racks">
      {racks.map((rack) => {
        const isPressed = selected.includes(rack.rackId);
        return (
          <RackChip
            key={rack.rackId}
            onClick={() => toggle(rack.rackId)}
            aria-pressed={isPressed}
          >
            {rack.name}
          </RackChip>
        );
      })}
    </div>
  );
};

export default RackPicker;
